export default __webpack_public_path__ + "static/media/Tabl_8.63d64e38.svg";